let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g0Dr6")).then(() => parcelRequire('6mRQz'));